import React, { useEffect } from "react";
import ReactGA from "react-ga";

function Imprint() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    ReactGA.pageview(window.location.pathname + window.location.search);
  });

  return (
    <>
      <div>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi impedit
        perferendis aperiam et vitae! Illum assumenda animi, et mollitia odio
        officiis illo maiores ea tenetur ipsam! Eos sed, impedit dolorem minus
        tempora odit itaque doloremque architecto at cupiditate tenetur
        provident, nostrum quas. Nobis, voluptatibus explicabo. Porro, magnam
        consequatur quos totam explicabo omnis labore, dolorum reiciendis alias
        commodi dolor fuga, voluptatem dolore. Quibusdam quasi nemo commodi. Ab
        cumque repudiandae quaerat rerum libero nihil dignissimos ratione,
        possimus officia consequatur commodi, voluptatibus dolor autem
        reprehenderit. Corrupti nihil perspiciatis numquam delectus laudantium
        rerum atque reiciendis, assumenda inventore, earum facilis architecto
        voluptatum, nam vel facere!
      </div>
    </>
  );
}

export default Imprint;
